import { css } from "@emotion/css";
import { mergeProps, VisuallyHidden } from "react-aria";
import {
  TableHeader as AriaTableHeader,
  Collection,
  Column,
  TableHeaderProps,
  useTableOptions,
} from "react-aria-components";
import { useTranslation } from "react-i18next";

import { TableCheckbox } from "./TableCheckbox";

export function TableHeader<T extends object>(props: TableHeaderProps<T>) {
  const { t } = useTranslation();

  const { columns, children, ...otherProps } = props;

  const { selectionBehavior, selectionMode, allowsDragging } =
    useTableOptions();

  return (
    <AriaTableHeader
      {...mergeProps(otherProps, { className: styles.tableHeader })}
    >
      {/* Add extra columns for drag and drop and selection. */}
      {allowsDragging && <Column />}
      {selectionBehavior === "toggle" && (
        <Column className={styles.checkboxCell} minWidth={48} maxWidth={48}>
          {selectionMode === "multiple" ? (
            <TableCheckbox />
          ) : (
            <VisuallyHidden>{t("Selection checkboxes")}</VisuallyHidden>
          )}
        </Column>
      )}
      <Collection items={columns}>{children}</Collection>
    </AriaTableHeader>
  );
}

const styles = {
  tableHeader: css({
    height: 60,
  }),
  checkboxCell: css({
    width: "35px",
    paddingTop: "var(--space-4)",
    paddingBottom: `calc(var(--space-4) - 2px)`,
    paddingLeft: "var(--space-2)",
    paddingRight: "var(--space-1)",
  }),
};
